import { isPlainObject } from 'lodash';
export const DELETE = 0;
export const SET = 1;
export const UPDATE = 2;
export const createPatch = (a, b) => {
    const result = {};
    for (const key in a) {
        if (!(key in b)) {
            result[key] = { t: DELETE };
            // @ts-expect-error
        }
        else if (a[key] === b[key]) {
            continue;
            // @ts-expect-error
        }
        else if (isPlainObject(a[key]) && isPlainObject(b[key])) {
            // @ts-expect-error
            result[key] = { t: UPDATE, v: createPatch(a[key], b[key]) };
        }
        else {
            // @ts-expect-error
            result[key] = { t: SET, v: b[key] };
        }
    }
    for (const key in b) {
        if (!(key in a)) {
            result[key] = { t: SET, v: b[key] };
        }
    }
    return result;
};
//# sourceMappingURL=create-patch.js.map